import React, { useEffect, useState, useRef } from "react";
import fastTypeBg from "../../../../images/fastTypeBg.png";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import zero from "../../../../images/fastNum0.png";
import one from "../../../../images/fastNum1.png";
import two from "../../../../images/fastNum2.png";
import three from "../../../../images/fastNum3.png";
import four from "../../../../images/fastNum4.png";
import five from "../../../../images/fastNum5.png";
import six from "../../../../images/fastNum6.png";
import seven from "../../../../images/fastNum7.png";
import eight from "../../../../images/fastNum8.png";
import nine from "../../../../images/fastNum9.png";
import "./FastParity.css";
import RecordTap from "./record/RecordTap";
import OrderTap from "./order/OrderTap";
import Timer from "./Timer";
import Bidcom from "../Bidcom";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none",
    },
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    border: "none",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: theme.shadows[5],

    "&:focus": {
      outline: "none",
    },

    position: "relative",
    borderRadius: "15px",
  },
}));
const FastParity = ({
  data,
  setcreategame,
  creategam,
  gettimefast,
  biddatafast,
  bidhistoryfast,
  resultfast,
  disable,
  setdisable,
  resulthistoryfast
}) => {
  const classes = useStyles();
  const [refetch, setrefetch] = useState(false);
  const [bidvalue, setbidvalue] = useState("");
  const [color, setcolor] = useState("");
  const [open, setOpen] = useState(false);
  const [period, setperiod] = useState("")
  const [paritytype, setparitytype] = useState("fastparity");
  
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
console.log(disable)
  useEffect(() => {

    setperiod(data ? data.period : "")
  }, [refetch, disable,  data]);

  return (
    <>
      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <Bidcom
                bidvalue={bidvalue}
                color={color}
                paritytype={paritytype}
                period={data ? data.period : ""}
                setOpen={setOpen}
                bidhistoryfast={bidhistoryfast}
              />
            </div>
          </Fade>
        </Modal>
      </div>
      <div className="allcenter">
        <div className="scrollbar-indiv ">
          <div className="cenperiod">
            <div>
              <p className="per">Period</p>
              <p className="pernum">{data ? data.period : ""}</p>
            </div>
            <div>
              <p className="Cout">Count Down</p>
              <Timer
                startingtime={data.startTime}
                currenttime={data.currentTime}
                setcreategam={setcreategame}
                creategam={creategam}
                gettimefast={gettimefast}
                setrefetch={setrefetch}
                refetch={refetch}
                setdisable={setdisable}
                onTimeOut={() => alert("ok")}
                resulthistoryfast={resulthistoryfast}
              />
            </div>
          </div>


          <div className="center-nav">
            <button
              onClick={() => {
                setbidvalue("Green");
                handleOpen();
                setcolor("green");
              }}
              disabled={disable ? true : false}
              className="over-btn"
            >
              <div>
                <div className={disable ? "joindisable" : "join"}>
                  <img src={fastTypeBg} alt="img" width={"40px"} />
                  <span className="mo">Join Green</span>
                </div>
                <div className="blow">1:2</div>
              </div>
            </button>

            <button
              onClick={() => {
                setbidvalue("Violet");
                handleOpen();
                setcolor("rgb(102, 85, 211)");
              }}
              disabled={disable ? true : false}
              className="over-btn"
            >
              <div>
                <div
                className={disable ? "voiletdisable " : "voilet"}
              >
                  <img src={fastTypeBg} alt="img" width={"40px"} />
                  <span className="mo">Join Violet</span>
                </div>
                <div className="blow">1:4.5</div>
              </div>
            </button>
            <button
              onClick={() => {
                setbidvalue("Red");
                handleOpen();
                setcolor("red");
              }}
              disabled={disable ? true : false}
              className="over-btn"
            >
              <div>
                <div
                 className={disable ? "reddisble" : "red"}
             >
                  <img src={fastTypeBg} alt="img" width={"40px"} />
                  <span className="mo">Join Red</span>
                </div>
                <div className="blow">1:2</div>
              </div>
            </button>
          </div>

          <div className="center-nav">
            <div>
              <div>
                <button
                  onClick={() => {
                    setbidvalue("1");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={one}
                    alt="now"
                  />
                </button>

                <button
                  onClick={() => {
                    setbidvalue("2");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={two}
                    alt="now"
                  />
                </button>

                <button
                  onClick={() => {
                    setbidvalue("3");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={three}
                    alt="now"
                  />
                </button>
                <button
                  onClick={() => {
                    setbidvalue("4");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={four}
                    alt="now"
                  />
                </button>
                <button
                  onClick={() => {
                    setbidvalue("5");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={five}
                    alt="now"
                  />
                </button>
              </div>
              <div>
                <button
                  onClick={() => {
                    setbidvalue("6");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={six}
                    alt="now"
                  />
                </button>
                <button
                  onClick={() => {
                    setbidvalue("6");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={seven}
                    alt="now"
                  />
                </button>
                <button
                  disabled={disable ? true : false}
                  onClick={() => {
                    setbidvalue("8");
                    handleOpen();
                    setcolor("");
                  }}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={eight}
                    alt="now"
                  />
                </button>
                <button
                  onClick={() => {
                    setbidvalue("9");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={nine}
                    alt="now"
                  />
                </button>
                <button
                  onClick={() => {
                    setbidvalue("0");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <img
                    className={disable ? "disble" : "tablenum"}
                    src={zero}
                    alt="now"
                  />
                </button>
              </div>
              <div className="texttable">1:9</div>
            </div>
          </div>


          <RecordTap biddatafast={resultfast} period1={period} />

          <OrderTap biddatafast={biddatafast} />
        </div>
      </div>
    </>
  );
};

export default FastParity;
